<mat-toolbar class="layout-row" id="LOSx-toolbar">
  @if (!sidenavCollapsed) {
    <button
      mat-icon-button
      (click)="toggleSidenav()"
      matTooltip="{{ 'tooltips.Toggle Hide/Open' | translate }}"
      tabindex="0"
    >
      <fa-icon icon="bars" size="lg"></fa-icon>
    </button>
  }

  @if (sidenav.opened) {
    <button
      mat-icon-button
      (click)="toggleSidenavCollapse()"
      matTooltip="{{ 'tooltips.Toggle Collapse' | translate }}"
      class="hide-lt-md"
      tabindex="0"
    >
      @if (!sidenavCollapsed) {
        <fa-icon icon="chevron-left"></fa-icon>
      }
      @if (sidenavCollapsed) {
        <fa-icon icon="chevron-right"></fa-icon>
      }
    </button>
  }

  <div class="tab-nav-bar">
    <a
      #institution
      class="tab-link"
      [matMenuTriggerFor]="institutionMenu"
      #institutionMenuTrigger="matMenuTrigger"
      tabindex="0"
    >
      <fa-icon class="mr-05" icon="university" size="lg"></fa-icon>
      {{ 'labels.menus.Institution' | translate }}
    </a>

    <span class="hide-lt-md">
      <a #accounting class="tab-link accounting-link" [routerLink]="['/accounting']" tabindex="0">
        <fa-icon class="mr-05" icon="money-bill-alt" size="lg"></fa-icon>
        {{ 'labels.menus.Accounting' | translate }}
      </a>
      <a #reports class="tab-link" [matMenuTriggerFor]="reportsMenu" #reportsMenuTrigger="matMenuTrigger" tabindex="0">
        <fa-icon class="mr-05" icon="chart-bar" size="lg"></fa-icon>
        {{ 'labels.menus.Reports' | translate }}
      </a>
      <a #admin class="tab-link" [matMenuTriggerFor]="adminMenu" #adminMenuTrigger="matMenuTrigger" tabindex="0">
        <fa-icon class="mr-05" icon="shield-alt" size="lg"></fa-icon>
        {{ 'labels.menus.Admin' | translate }}
      </a>
      <a #configWizard class="tab-link" (click)="openDialog()" tabindex="0">
        <fa-icon class="mr-05" icon="info" size="lg"></fa-icon>
        {{ 'labels.menus.Configuration Wizard' | translate }}
      </a>
    </span>
  </div>

  <span class="toolbar-spacer"></span>

  <div #globalSearch class="white-text-search">
    <LOSx-search-tool tabindex="0"></LOSx-search-tool>
  </div>

  <div #languageSelector class="white-text-language">
    <LOSx-language-selector class="ml-1 language hide-lt-md" tabindex="0"></LOSx-language-selector>
  </div>

  <button mat-icon-button [matMenuTriggerFor]="languageMenu" tabindex="0">
    <mat-icon class="lg-icon">language</mat-icon>
  </button>

  <div #notifications>
    <LOSx-notifications-tray #notificationsTray class="hide-lt-md" tabindex="0"></LOSx-notifications-tray>
  </div>

  <div #themeToggle>
    <LOSx-theme-toggle tabindex="0"></LOSx-theme-toggle>
  </div>

  <div #appMenu>
    <button mat-icon-button class="ml-1 img-button" [matMenuTriggerFor]="applicationMenu" tabindex="0">
      <fa-icon icon="user-circle" [attr.aria-label]="'labels.headings.User Profile' | translate"></fa-icon>
    </button>
  </div>
</mat-toolbar>

<!-- Language selector menu for small screen view -->
<mat-menu #languageMenu="matMenu">
  <LOSx-language-selector class="ml-1 language"></LOSx-language-selector>
</mat-menu>

<mat-menu #institutionMenu="matMenu" [overlapTrigger]="false">
  <button mat-menu-item routerLink="/clients" tabindex="0">{{ 'labels.menus.Clients' | translate }}</button>
  <button mat-menu-item routerLink="/groups" tabindex="0">{{ 'labels.menus.Groups' | translate }}</button>
  <button mat-menu-item routerLink="/centers" tabindex="0">{{ 'labels.menus.Centers' | translate }}</button>
  <span class="hide-lt-md">
    <button mat-menu-item [routerLink]="['/accounting']" tabindex="0">
      {{ 'labels.menus.Accounting' | translate }}
    </button>
    <button mat-menu-item [matMenuTriggerFor]="reportsMenu" tabindex="0">
      {{ 'labels.menus.Reports' | translate }}
    </button>
    <button mat-menu-item [matMenuTriggerFor]="adminMenu" tabindex="0">{{ 'labels.menus.Admin' | translate }}</button>
  </span>
</mat-menu>

<!-- Toolbar Menus -->
<mat-menu #reportsMenu="matMenu" [overlapTrigger]="false">
  <button mat-menu-item [routerLink]="['/reports']" tabindex="0">{{ 'labels.menus.All' | translate }}</button>
  <button mat-menu-item [routerLink]="['/reports', 'Client']" tabindex="0">
    {{ 'labels.menus.Clients' | translate }}
  </button>
  <button mat-menu-item [routerLink]="['/reports', 'Loan']" tabindex="0">{{ 'labels.menus.Loans' | translate }}</button>
  <button mat-menu-item [routerLink]="['/reports', 'Savings']" tabindex="0">
    {{ 'labels.menus.Savings' | translate }}
  </button>
  <button mat-menu-item [routerLink]="['/reports', 'Fund']" tabindex="0">{{ 'labels.menus.Funds' | translate }}</button>
  <button mat-menu-item [routerLink]="['/reports', 'Accounting']" tabindex="0">
    {{ 'labels.menus.Accounting' | translate }}
  </button>
</mat-menu>

<mat-menu #adminMenu="matMenu" [overlapTrigger]="false">
  <button mat-menu-item (click)="navigateMenu('/appusers')" tabindex="0">{{ 'labels.menus.Users' | translate }}</button>
  <button mat-menu-item [routerLink]="['/organization']" tabindex="0">
    {{ 'labels.menus.Organization' | translate }}
  </button>
  <button mat-menu-item [routerLink]="['/system']" tabindex="0">{{ 'labels.menus.System' | translate }}</button>
  <button mat-menu-item [routerLink]="['/products']" tabindex="0">{{ 'labels.menus.Products' | translate }}</button>
  <button mat-menu-item routerLink="/templates" tabindex="0">{{ 'labels.menus.Templates' | translate }}</button>
</mat-menu>

<!-- Application User Help Menu -->
<mat-menu #applicationMenu="matMenu" [overlapTrigger]="false">
  <button mat-menu-item (click)="help()" tabindex="0">
    <mat-icon matListIcon>
      <fa-icon icon="question-circle" size="sm"></fa-icon>
    </mat-icon>
    <span>{{ 'labels.menus.Help' | translate }}</span>
  </button>
  <button mat-menu-item [routerLink]="['/profile']" tabindex="0">
    <mat-icon>
      <fa-icon icon="user" size="sm"></fa-icon>
    </mat-icon>
    <span>{{ 'labels.menus.Profile' | translate }}</span>
  </button>
  <button mat-menu-item [routerLink]="['/settings']" tabindex="0">
    <mat-icon>
      <fa-icon icon="cog" size="sm"></fa-icon>
    </mat-icon>
    <span>{{ 'labels.menus.Settings' | translate }}</span>
  </button>
  <button mat-menu-item (click)="logout()" id="logout" tabindex="0">
    <mat-icon>
      <fa-icon icon="sign-out-alt" size="sm"></fa-icon>
    </mat-icon>
    <span>{{ 'labels.menus.Sign Out' | translate }}</span>
  </button>
</mat-menu>

<ng-template #templateInstitution let-popover="popover">
  <h2>{{ 'labels.menus.Institution' | translate }}</h2>
  <p class="mw300">{{ 'labels.text.Button for individual account' | translate }}</p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); showPopover(templateAccounting, accounting)">
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #templateAccounting let-popover="popover">
  <h2>{{ 'labels.menus.Accounting' | translate }}</h2>
  <p class="mw300">{{ 'labels.text.Button for accounting department' | translate }}</p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); showPopover(templateInstitution, institution)">
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); showPopover(templateReports, reports)">
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #templateReports let-popover="popover">
  <h2>{{ 'labels.menus.Reports' | translate }}</h2>
  <p class="mw300">{{ 'labels.text.Dropdown system reports' | translate }}</p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); showPopover(templateAccounting, accounting)">
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); showPopover(templateAdmin, admin)">
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #templateAdmin let-popover="popover">
  <h2>{{ 'labels.menus.Admin' | translate }}</h2>
  <p class="mw300">{{ 'labels.text.Setup organization including users' | translate }}</p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); showPopover(templateReports, reports)">
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); showPopover(templateSelfService, selfService)">
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #templateSelfService let-popover="popover">
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); showPopover(templateAdmin, admin)">
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="popover.close(); showPopover(templateConfigWizard, configWizard)"
    >
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #templateConfigWizard let-popover="popover">
  <h2>{{ 'labels.menus.Configuration Wizard' | translate }}</h2>
  <p class="mw300">{{ 'labels.text.Initial setup and application tour' | translate }}</p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); showPopover(templateSelfService, selfService)">
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="popover.close(); showPopover(templateGlobalSearch, globalSearch)"
    >
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #templateGlobalSearch let-popover="popover">
  <h2>{{ 'labels.menus.Global Search' | translate }}</h2>
  <p class="mw300">{{ 'labels.text.Navigate system selecting entity' | translate }}</p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="popover.close(); showPopover(templateConfigWizard, configWizard)"
    >
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="popover.close(); showPopover(templateLanguageSelector, languageSelector)"
    >
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #templateLanguageSelector let-popover="popover">
  <h2>{{ 'labels.menus.Language Selector' | translate }}</h2>
  <p class="mw300">{{ 'labels.text.Organization available languages' | translate }}</p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="popover.close(); showPopover(templateGlobalSearch, globalSearch)"
    >
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="popover.close(); showPopover(templateNotifications, notifications)"
    >
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #templateNotifications let-popover="popover">
  <h2>{{ 'labels.menus.Notifications' | translate }}</h2>
  <p class="mw300">{{ 'labels.text.This shows all the notifications.' | translate }}</p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="popover.close(); showPopover(templateLanguageSelector, languageSelector)"
    >
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); showPopover(templateThemePicker, themeToggle)">
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #templateThemePicker let-popover="popover">
  <h2>{{ 'labels.menus.Theme Picker' | translate }}</h2>
  <p class="mw300">{{ 'labels.text.Choose to work with a dark or bright background' | translate }}</p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="popover.close(); showPopover(templateNotifications, notifications)"
    >
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); showPopover(templateAppMenu, appMenu)">
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #templateAppMenu let-popover="popover">
  <h2>{{ 'labels.menus.Application Menu' | translate }}</h2>
  <p class="mw300">{{ 'labels.text.User settings and sign out button' | translate }}</p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); showPopover(templateThemePicker, themeToggle)">
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); nextStep()">
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>
